/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Monthly_Metrics_Top_MonthInputs */

const es_billing_monthly_metrics_top_month = /** @type {(inputs: Billing_Monthly_Metrics_Top_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes con mayor facturación`)
};

const en_billing_monthly_metrics_top_month = /** @type {(inputs: Billing_Monthly_Metrics_Top_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highest billing month`)
};

/**
* | output |
* | --- |
* | "Highest billing month" |
*
* @param {Billing_Monthly_Metrics_Top_MonthInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_monthly_metrics_top_month = /** @type {((inputs?: Billing_Monthly_Metrics_Top_MonthInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Monthly_Metrics_Top_MonthInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_monthly_metrics_top_month(inputs)
	return en_billing_monthly_metrics_top_month(inputs)
});
export { billing_monthly_metrics_top_month as "billing.monthly.metrics.top_month" }